import { Image, SectionProps } from 'shared-types'
import { CategoryCardProps } from '~/components/CategoryCard/CategoryCard.types'
import { ProductCardProps } from '~/components/ProductCard/ProductCard.types'
import { ProjectCardProps } from '~/components/ProjectCard/ProjectCard.types'
import { BrandCategoryCardProps } from '../../components/BrandCategoryCard/BrandCategoryCard.types'
import { SimpleCategoryCardProps } from '../../components/SimpleCategoryCard/SimpleCategoryCard.types'

export enum CardTypes {
  CATEGORY = 'category-card',
  CATEGORY_V2 = 'category-card-v2',
  PROJECT = 'project-card',
  PRODUCT = 'product-card',
  BRAND = 'brand-card',
}

export type Card =
  | ({
      cardType: CardTypes.CATEGORY
    } & CategoryCardProps)
  | ({
      cardType: CardTypes.PROJECT
    } & ProjectCardProps)
  | ({
      cardType: CardTypes.PRODUCT
    } & ProductCardProps)
  | ({
      cardType: CardTypes.CATEGORY_V2
    } & SimpleCategoryCardProps)
  | ({
      cardType: CardTypes.BRAND
    } & BrandCategoryCardProps)

export interface ICards extends SectionProps {
  title: string
  titleAlignment: 'left' | 'center' | 'right'
  paragraph: string
  seeMoreText: string
  seeMoreUrl: string
  seeMoreOpenInNewWindow?: boolean
  cards: Card[]
  backgroundColor?: string
  image?: Image
  isDesktopCarouselDisabled?: boolean
  isMobileCarouselDisabled?: boolean
  rowItemCountOnDesktop?: number
  rowItemCountOnMobile?: number
  categorySku?: string
  marketingTile?: {
    desktop: Image
    tablet: Image
    mobile: Image
  }
  marketingTileAtStart?: boolean
  marketingTileAtEnd?: boolean
  titleColor?: string
}
